import { Pages } from "./pages";
import { Utility } from "./utility";

export const Norwegian = {
	Pages,
	Utility,
};
